import { TextField } from '@mui/material';
import { SyntheticEvent, useCallback, useContext, useEffect, useState } from 'react';

import CharacterLimitHelperText from '@/components/common/CharacterLimitHelperText';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function HealthcareSystemNameInput() {
  const [healthcareSystemName, setHealthcareSystemName] = useState<string | null>(null);
  const { partnerGroupInfo, intakeLabels, updatePartnerGroupInfo, showErrors } =
    useContext(PartnerIntakeContext);

  const handleHealthcareSystemNameChange = useCallback(
    (e: SyntheticEvent) => {
      const updatedValue = (e.target as HTMLInputElement).value;

      setHealthcareSystemName(updatedValue);

      const updatedPartnerGroup = {
        ...partnerGroupInfo,
        partnerName: updatedValue,
      };

      if (updatePartnerGroupInfo) {
        updatePartnerGroupInfo(updatedPartnerGroup);
      }
    },
    [updatePartnerGroupInfo, partnerGroupInfo]
  );

  useEffect(() => {
    if (partnerGroupInfo?.partnerName != healthcareSystemName)
      setHealthcareSystemName(partnerGroupInfo?.partnerName ?? null);
  }, [partnerGroupInfo?.partnerName, healthcareSystemName]);

  return (
    <>
      <TextField
        variant='outlined'
        sx={{ flexGrow: 1 }}
        onChange={handleHealthcareSystemNameChange}
        value={healthcareSystemName ? healthcareSystemName : ''}
        label={intakeLabels.healthcareSystem ?? 'School District'}
        id={'HealthcareSystemName'}
        required
        error={
          showErrors &&
          (!partnerGroupInfo?.partnerName ||
            (healthcareSystemName != null && healthcareSystemName?.length >= 1000))
        }
      />
      {healthcareSystemName && healthcareSystemName.length >= 1000 && (
        <CharacterLimitHelperText limit={1000} />
      )}
    </>
  );
}

export default HealthcareSystemNameInput;
